import { Flex } from "@/atoms"
import { List } from "@/molecules/List"

import type { CVEIncident } from "@/domain/adr"
import type { TFunction } from "@/hooks/useTranslation"

export const FunctionList = ({
  record,
  t
}: {
  record: CVEIncident
  t: TFunction
}) => {
  const limit = 3
  const count = record.what.vulnerabilities.length - limit

  return (
    <Flex vertical>
      <List
        limit={limit}
        items={record.what.vulnerabilities}
        render={(value) => <div>{value.vulnerableFunctions?.[0] || "-"}</div>}
        showMoreTitle={`+${count} ${t("vulnerable function", { count })}`}
      />
    </Flex>
  )
}
